import { render } from "./pegawai-add.vue?vue&type=template&id=7eb4de06"
import script from "./pegawai-add.vue?vue&type=script&lang=js"
export * from "./pegawai-add.vue?vue&type=script&lang=js"

import "./pegawai-add.vue?vue&type=style&index=0&id=7eb4de06&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__